import { TRPCClientError } from '@trpc/client'
import type { AppRouter } from '../appRouter'

export type TrpcClientError = TRPCClientError<AppRouter>
export type TrpcErrorCode = NonNullable<TrpcClientError['data']>['code']

export function isTrpcClientError(error: unknown): error is TrpcClientError {
  return error instanceof TRPCClientError
}

export function getTrpcErrorCode(error: unknown): TrpcErrorCode | undefined {
  if (!isTrpcClientError(error)) {
    return undefined
  }

  return error.data?.code
}

export function isUserFacingTrpcError(error: unknown): error is TrpcClientError {
  return isTrpcClientError(error) && error.message !== 'INTERNAL_SERVER_ERROR'
}

export function isTrpcErrorCode(error: unknown, code: TrpcErrorCode): boolean {
  return getTrpcErrorCode(error) === code
}
